/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Tab_StatusInputs */

const vi_warehouse_sales_tab_status = /** @type {(inputs: Warehouse_Sales_Tab_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tình trạng kho`)
};

/**

* @param {Warehouse_Sales_Tab_StatusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_tab_status = /** @type {((inputs?: Warehouse_Sales_Tab_StatusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Tab_StatusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_tab_status(inputs)
});